// import React, { useEffect, useState } from "react";
// import "../ProductCategory/productCategory.scss";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DescriptionTypeSubCategorys from "../../../../components/DescriptionType/DescriptionTypeSubCategorys";
// import { API_BASE_URL } from "../../../../utils/index";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import DescriptionTypeCategorys from "../../../../components/DescriptionType/DescriptionTypeCategorys";
// import { useAuthHeaders } from "../../../../components/Token";
// import CancelButton from "../../../../components/MinorComponents/CancelButton";

// function CreateDescriptionVendorType() {
//   const [category, setCategory] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [submitCategory, setSubmitCategory] = useState("");
//   const [subCategory, setSubCategory] = useState([]);
//   const [selectedSubCategory, setSelectedSubCategory] = useState("");
//   const [descriptionName, setDescriptionName] = useState("");
//   const navigate = useNavigate();
//   const headers = useAuthHeaders();

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/category/admin/getcategory`, { headers })
//       .then((response) => {
//         // Update the state with the fetched subcategory data
//         setCategory(response.data?.categories);
//         // console.log(response.data.categories, "getcategory")
//       })
//       .catch((error) => {
//         console.error("Error fetching subcategory data:", error);
//       });
//   }, []);

//   const handleCategoryCreation = (e) => {
//     e.preventDefault();

//     axios
//       .post(
//         `${API_BASE_URL}/description/admin/descriptionname`,
//         {
//           descriptionName: descriptionName,
//           subcategoryname: selectedSubCategory,
//           categoryname: submitCategory,
//         },
//         {
//           headers,
//         }
//       )
//       .then((result) => {
//         console.log(result);
//         Swal.fire({
//           icon: "success",
//           title: "Description Name has been saved",
//           showConfirmButton: false,
//           timer: 1500,
//         });
//         navigate("/descriptionType");
//       })
//       .catch((error) => {
//         console.log(error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: error.response.data.error,
//         });
//       });
//   };

//   return (
//     <div className="p-3" >
//       <h2>Create Description Name</h2>
//       <form onSubmit={handleCategoryCreation} className="category" style={{ boxShadow: "0 0 10px 0 rgba(0,0,0,0.45) inset" }}>
//         <div className="row category-field">
//           <DescriptionTypeCategorys
//             setSelectedCategory={setSelectedCategory}
//             selectedCategory={selectedCategory}
//             category={category}
//             setSubCategory={setSubCategory}
//             setSubmitCategory={setSubmitCategory}
//             submitCategory={submitCategory}
//           />

//           <DescriptionTypeSubCategorys
//             selectedSubCategory={selectedSubCategory}
//             setSelectedSubCategory={setSelectedSubCategory}
//             subCategory={subCategory}
//           />

//           <div className="col-md-6">
//             <label htmlFor="name" className="fs-6">
//               description Name:
//             </label>
//             <br />
//             <input
//               type="text"
//               id="descriptionName"
//               onChange={(e) => setDescriptionName(e.target.value)}
//               required
//             />
//           </div>
//         </div>
//         <div className="buttons">
//           <button type="submit" style={{ backgroundColor: "#0443C0", color: "white" }}>Save</button>
//           <CancelButton path="/descriptionType" />
//         </div>
//       </form>
//       {/*  */}
//     </div>
//   );
// }

// export default CreateDescriptionVendorType;
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Snackbar,
  Alert,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CancelButton from "../../../../components/MinorComponents/CancelButton";
import DescriptionTypeCategorys from "../../../../components/DescriptionType/DescriptionTypeCategorys";
import DescriptionTypeSubCategorys from "../../../../components/DescriptionType/DescriptionTypeSubCategorys";
import { POSTVendorDESC } from "../../../../services/api/Descriptions";
import { GetVendorCategory } from "../../../../services/api/Category";

function CreateDescriptionVendorType() {
  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [submitCategory, setSubmitCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [descriptionName, setDescriptionName] = useState("");
  const slugname = localStorage.getItem("vendorsubdomain");

  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });


  const navigate = useNavigate();

  useEffect(() => {
    // axios
    //   .get(`${API_BASE_URL}/category/admin/getcategory`, { headers })
    //   .then((response) => {
    //     setCategory(response.data?.categories || []);
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching categories:", error);
    //     setSnackbar({ open: true, message: "Failed to fetch categories", severity: "error" });
    //   });

    const fetchHalder = async () => {
      const response = await GetVendorCategory(slugname)
      if (response.success) {
        setCategory(response?.categories || [])
      }
    }
    fetchHalder()
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // await axios.post(
      //   `${API_BASE_URL}/description/admin/descriptionname`,
      // {
      //   descriptionName,
      //   subcategoryname: selectedSubCategory,
      //   categoryname: submitCategory,
      // },
      //   { headers }
      // );
      const payload = {
        descriptionName,
        subcategoryname: selectedSubCategory,
        categoryname: submitCategory,
      }
      const response = await POSTVendorDESC(slugname, payload)
      console.log(response, "response:")
      if (response.success) {

        setSnackbar({
          open: true,
          message: response.message,
          severity: "success",
        });

        setTimeout(() => navigate(`/${slugname}/master/description-name`), 1500);
      } else {
        setSnackbar({
          open: true,
          message: response?.data?.message || "Failed to save description",
          severity: "error",
        });
      }

    } catch (error) {
      console.error(error);
      setSnackbar({
        open: true,
        message: error?.response?.data?.error || "Failed to save description",
        severity: "error",
      });
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Create Description Name
      </Typography>

      <Paper
        component="form"
        onSubmit={handleSubmit}
        sx={{
          p: 3,
          boxShadow: "0 0 10px 0 rgba(0,0,0,0.45) inset",
          backgroundColor: "#f9f9f9",
        }}
      >
        <Box className="row category-field" sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
          <DescriptionTypeCategorys
            category={category}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            setSubCategory={setSubCategory}
            setSubmitCategory={setSubmitCategory}
            submitCategory={submitCategory}
          />

          <DescriptionTypeSubCategorys
            subCategory={subCategory}
            selectedSubCategory={selectedSubCategory}
            setSelectedSubCategory={setSelectedSubCategory}
          />

          <Box className="col-md-6" sx={{ flex: 1, minWidth: 250 }}>
            <Typography variant="body2" mb={1}>
              Description Name
            </Typography>
            <TextField
              id="descriptionName"
              variant="outlined"
              size="small"
              fullWidth
              required
              value={descriptionName}
              onChange={(e) => setDescriptionName(e.target.value)}
            />
          </Box>
        </Box>

        <Box mt={3} display="flex" gap={2}>
          <Button
            type="submit"
            variant="contained"
            sx={{
              backgroundColor: "#0443C0",
              "&:hover": { backgroundColor: "#0333a0" },
              color: "#fff",
            }}
          >
            Save
          </Button>
          <CancelButton path={`/${slugname}/master/description-name`} />
        </Box>
      </Paper>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default CreateDescriptionVendorType;
